import { useCallback, useMemo } from 'react';
import { Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { useFormValues, useSetFieldValue } from '@s20/components/forms/FormContext';
import { SmallButton } from '../../../../common/forms/FormElements';

export const Certification = ({ ...cert }) => {
    const selectedCertifications = useFormValues('selectedCertifications');
    const setFieldValue = useSetFieldValue();

    const isCertificationSelected = useMemo(() => selectedCertifications?.includes(cert.id), [selectedCertifications, cert]);

    const handleCertificationButtonClick = useCallback(() => {
        let certs = [...(selectedCertifications || [])];

        if (certs.includes(cert.id)) {
            certs = certs.filter((cId) => cId !== cert.id);
        } else {
            certs.push(cert.id);
        }

        setFieldValue('selectedCertifications', certs);
    }, [cert.id, setFieldValue, selectedCertifications]);

    console.log({ cert });

    return (
        <SmallButton
            key={cert.id}
            className="border mr-2 ml-0 d-flex align-items-center"
            onClick={() => handleCertificationButtonClick()}
            selected={isCertificationSelected}
        >
            {cert.quantity > 0 ? (
                <Badge
                    color="info"
                    className="mr-1"
                >
                    {cert.quantity}
                </Badge>
            ) : (
                <FontAwesomeIcon
                    icon={faCheck}
                    className="mr-1 text-success"
                />
            )}

            <span>{cert.abbreviation}</span>
        </SmallButton>
    );
};